import { computed, ref, watch } from '@vue/composition-api';
import { animationGenerator, linear, transitionFunctionMap } from './animation-func'; // 为啥这里opts:Ref<TransitionOptions>|ComputedRef<TransitionOptions>在项目里引用类型Ref兼容不了

export var useTransitionHook = function useTransitionHook(opts) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (fn) {
      return setTimeout(fn, 17);
    };
  } // 就是给个默认值


  var myOptions = computed(function () {
    return {
      value: opts.value.value || 0,
      delay: opts.value.delay || 0,
      duration: opts.value.duration === undefined ? 500 : opts.value.duration,
      timingFunction: opts.value.timingFunction || 'linear'
    };
  });
  var realValue = ref(myOptions.value.value);
  var finalDistance = 0;
  var currentTime = 0;
  var startDistance = 0;

  var emit = function emit(name, value) {
    if (opts.value[name] && typeof opts.value[name] === 'function') {
      opts.value[name](value);
    }
  };

  var sleep = function sleep(ms) {
    return new Promise(function (resolve) {
      return ms === 0 ? resolve('') : setTimeout(resolve, ms);
    });
  };

  var realFunction = computed(function () {
    if (typeof opts.value.easyFunction === 'function' && opts.value.easyFunction.length === 1) {
      return animationGenerator(opts.value.easyFunction);
    }

    if (typeof opts.value.customFunction === 'function') {
      if (opts.value.customFunction.length === 4) {
        return opts.value.customFunction;
      }

      return linear;
    }

    if (myOptions.value.timingFunction) {
      return transitionFunctionMap[myOptions.value.timingFunction];
    }

    return linear;
  });

  var handleTransitionStart = function handleTransitionStart() {
    currentTime = new Date().getTime();
    emit('onTransitionStart');
  };

  var isAnimating = false;

  var handleTransitionEnd = function handleTransitionEnd() {
    isAnimating = false;
    emit('onTransitionEnd');
  };

  var handleChange = function handleChange(newVal, oldVal) {
    finalDistance = newVal;
    startDistance = realValue.value;
    sleep(myOptions.value.delay).then(function () {
      handleTransitionStart();

      if (!isAnimating) {
        doAnimate();
      }
    });
  };

  var doAnimate = function doAnimate() {
    if (myOptions.value.duration === 0) {
      realValue.value = myOptions.value.value;
      handleTransitionEnd();
      return;
    }

    isAnimating = true;
    var nowTime = new Date().getTime();
    var t = nowTime - currentTime;

    if (t > myOptions.value.duration) {
      t = myOptions.value.duration;
    }

    var change = finalDistance - startDistance;
    realValue.value = realFunction.value(t, startDistance, change, myOptions.value.duration);
    emit('onChange', realValue.value);

    if (t < myOptions.value.duration) {
      window.requestAnimationFrame(doAnimate);
    } else {
      setTimeout(function () {
        handleTransitionEnd();
      });
    }
  };

  watch(function () {
    return myOptions.value.value;
  }, function (newVal, oldVal) {
    handleChange(newVal, oldVal);
  });
  return {
    realValue: realValue
  };
};